import './App.css'
import {Configure, InstantSearch} from "react-instantsearch";
import config from "./lib/config.ts";
import {liteClient as algoliasearch} from "algoliasearch/lite";
import 'instantsearch.css/themes/satellite.css';
import {APIProvider} from "@vis.gl/react-google-maps";
import {AppProvider} from "./providers/AppProvider.tsx";
import DesktopApp from "./views/DesktopApp.tsx";
import {isMobileDevice} from "./lib/utils.ts";
import MobileApp from "./views/MobileApp.tsx";
import {HashRouter, Route, Routes, useNavigate} from "react-router-dom";
import Quiz from "./views/Quiz.tsx";
import MensQuiz from "./views/MensQuiz.tsx";
import ContactProviderForm from "./views/ContactProviderForm.tsx";
import {useEffect} from "react";

const searchClient = algoliasearch(config.algolia_app_id, config.algolia_search_api_key);

// Extend Window interface to include custom properties
declare global {
    interface Window {
        EVEXIAS_START_QUIZ?: boolean;
        EVEXIAS_START_MENS_QUIZ?: boolean;
        EVEXIAS_SHOW_CONTACT_FORM?: boolean;
        EVEXIAS_CONTACT_PRACTICE?: {
            id: number;
            name: string;
            address: string;
            phone?: string;
            phone_formatted?: string;
            slug: string;
            external_id?: number;
        };
    }
}

const LocatorApp = () => {
    return (
        <AppProvider defaultState={{
            isMobileDevice: isMobileDevice()
        }}>
            {isMobileDevice() ? <MobileApp/> : <DesktopApp/>}
        </AppProvider>
    )
}

const AutoRouteHandler = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Check if the global variable is set to start with quiz or contact form
        if (window.EVEXIAS_START_QUIZ === true) {
            navigate('/quiz', {replace: true});
        } else if (window.EVEXIAS_START_MENS_QUIZ === true) {
            navigate('/mens-quiz', {replace: true});
        } else if (window.EVEXIAS_SHOW_CONTACT_FORM === true) {
            navigate('/contact-provider', {replace: true});
        }
    }, [navigate]);

    return null;
};

function App() {

    return (
        <HashRouter>
            <AutoRouteHandler/>
            <InstantSearch
                searchClient={searchClient} indexName={config.algolia_index_name} future={{
                preserveSharedStateOnUnmount: true
            }}>
                <Configure aroundLatLngViaIP={true} getRankingInfo={true} hitsPerPage={30}/>
                <APIProvider
                    apiKey={'AIzaSyDvFCKgg9FmpGIzT0geHsLZ3JwtEYv9GOg'}
                    region={'US'}
                    libraries={[]}
                    language={'en'}
                >
                    <Routes>
                        <Route path="/" element={<LocatorApp/>}/>
                        <Route path="/quiz" element={<Quiz/>}/>
                        <Route path="/mens-quiz" element={<MensQuiz/>}/>
                        <Route path="/contact-provider" element={<ContactProviderForm/>}/>
                    </Routes>
                </APIProvider>
            </InstantSearch>
        </HashRouter>
    )
}

export default App
